<template>
  <div style="margin-top: 60px;">
    <div>

      <div
        class="table__header "
        style="margin-bottom: 15px !important; justify-content: space-between;"
      >
        <div style="display:flex; padding-right: 15px;">
          <div class="search-toggle">

            <p>{{ $t('SearchBy') }}</p>
            <div>
              <p
                :class="{ active2: toggleSarch }"
              >
                {{ $t('ProductName') }}
              </p>
            </div>
          </div>
          <div
            class="table__search-input"
            style="margin-right: 30px"
          >
            <b-icon-search />
            <input
              autocomplete="off"
              :placeholder="$t('ProductName')"
              type="text"
            >
          </div>
        </div>
        <button
          v-b-modal.modal-1
          class="button"
          style="width:195px; border-radius:6px; background: #FF274F !important;
  color: #f4f1ed;
  border-color: transparent;"
          @click="ExportExcel('xls')"
        >
          {{ $t('ExportToExcel') }}
        </button>
      </div>
      <div style="width: 100%;  padding-top: 16px; margin-top: 15px;">
        <table
          ref="exportable_table"
          class="team_table"
        >
          <thead>
            <tr>
              <th>
                {{ $t('ProductName') }}
              </th>
              <th>
                {{ $t('Size') }}
              </th>
              <th>
                {{ $t('ProductionTeam') }}
              </th>
              <th>
                {{ $t('Dateofassigned') }}
              </th>
              <th>
                {{ $t('Dateofcompleted') }}
              </th>
              <th>
                {{ $t('CustomerName') }}
              </th>
              <th>
                {{ $t('ShippingCountry') }}
              </th>
              <th>
                {{ $t('OrderType') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <!-- {{ supplier.supplierName }} -->
                test
              </td>
              <td>
                <!-- {{ supplier.contactName }} -->
                test
              </td>
              <td>
                <!-- {{ supplier.email }} -->
                test
              </td>
              <td>
                <!-- {{ supplier.phone }} -->
                test12
              </td>
              <td>
                <!-- {{ supplier.street }} -->
                test
              </td>
              <!-- <td
                style="padding: 9px; text-align: left; cursor: pointer"
              >
                <p
                  v-b-modal.modal-edit
                  class="p-0 m-0 ml-50"
                >
                  <b-icon-pencil />
                </p>
              </td> -->
              <!-- <td>
                <p
                  v-b-modal.modal-deactivate
                  class="p-0 m-0 ml-50"
                >
                  <toggle-button :value="true" />
                </p>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div>
        <b-pagination
          v-model="page"
          :total-rows="getTotalItemsForSuppliers"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span>Previous</span>
          </template>
          <template #next-text>
            <span>Next</span>
          </template>
        </b-pagination>
      </div>
    </div> -->
      <!-- <AddSupplierModal @supplier="addS" />
    <EditRowModal
      :edit-supp="editSupp"
      @edit="editSup"
    /> -->
      <!-- <DeactivateModal
      :edit-id="deactivateItemId"
      @objData="deactivateId"
    />
  </div> -->
    </div></div></template>

<script>
import * as XLSX from 'xlsx'


export default {
  methods: {
    ExportExcel(type, fn, dl) {
      const elt = this.$refs.exportable_table;
      const wb = XLSX.utils.table_to_book(elt, { sheet: 'Sheet JS' });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' })
        : XLSX.writeFile(wb, fn || (`SheetJSTableExport.${type || 'xlsx'}`))
    },
  },
};
</script>

<style>
.team_table {
  padding: 16px 9px;
}
</style>
